<script>
import FaIcon from 'vue-awesome/components/Icon'

export default {
  ...FaIcon,
  name: 'veui-icon'
}
</script>

<style lang="less" src="@/components/icon.less"></style>
